import TagManager from 'react-gtm-module';
import { TAG_MANAGER_ARG } from '../constants/gtm';
import isDev from './isDev';

export const initGtm = () => {
  if (!isDev) {
    TagManager.initialize(TAG_MANAGER_ARG);
  }
};
